













































































import { Component } from 'vue-property-decorator';
import SaascadaVue from '@/components/Shared/SaascadaVue';
import { WebhooksModule } from '@/store/Settings/WebhooksModule';
import WebhookEdit from '@/components/Settings/Webhooks/WebhookEdit.vue';
import { VuetifyConfirmObject } from 'vuetify-confirm';
import PageNames from '@/router/PageNames';
import PermissionUtils from '@/lib/permissionUtils';

@Component({ name: 'WebhookDetails', components: { WebhookEdit } })
export default class extends SaascadaVue {

    PermissionUtils = PermissionUtils;

    get webhook() {
        return WebhooksModule.webhook;
    }

    async deleteWebhook() {
        const options: VuetifyConfirmObject = {
            buttonTrueText: "Delete",
            buttonFalseText: "Close",
            buttonTrueColor: "primary",
            buttonFalseColor: "primary",
        }
        const result = await this.$confirm('Are you sure you want to delete this webhook?', options);
        if (result) {
            await WebhooksModule.deleteWebhook();
            this.$router.push({ name: PageNames.Webhooks });
        }
    }
}
